import { Select, Slider, Button } from "antd";
import { CaretRightOutlined } from "@ant-design/icons";

export default function MenuComponent({
  tipoMapa,
  setTipoMapa,
  regiones,
  setRegionSelect,
  setAnnoSelect,
  annoSelect,
  handleAnno,
  handlePlay,
  dataProyectada,
}) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        flexWrap: "wrap",
        gap: "36px",
        alignItems: "center",
        padding: "12px",
      }}
    >
      <Select
        defaultValue="País"
        style={{
          width: "100%",
          maxWidth: "100px",
        }}
        onChange={(val) => setTipoMapa(val)}
        options={[
          {
            value: "País",
            label: "País",
          },
          {
            value: "Regional",
            label: "Regional",
          },
        ]}
      />

      <Select
        defaultValue={regiones[0]}
        style={{
          width: "100%",
          maxWidth: "250px",
        }}
        onChange={(val) => setRegionSelect(val)}
        options={regiones.map((el) => {
          return { value: el, label: el };
        })}
        disabled={tipoMapa === "País"}
      />

      <div
        style={{
          width: "100%",
          maxWidth: "400px",
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          gap: "12px",
          alignItems: "center",
        }}
      >
        <Button
          type="primary"
          shape="circle"
          icon={<CaretRightOutlined />}
          onClick={handlePlay}
        />
        <Slider
          value={annoSelect}
          defaultValue={annoSelect}
          min={2012}
          max={2022}
          onChange={(val) => handleAnno(val, dataProyectada)}
          style={{
            width: "70%",
            maxWidth: "250px",
          }}
        />
        {annoSelect}
      </div>
    </div>
  );
}
